const ISODateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})$/;

class DateUtils
{
    static getDottedDate(date: Date): string {
        return date.toLocaleDateString('de-DE', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        });
    }

    static getHumanDate(date: Date): string {
        return date.toLocaleDateString('nl-NL', {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
        });
    }

    static getHumanTime(date: Date): string {
        return date.toLocaleTimeString('nl-NL', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
        }) + ' uur';//.replace(':', 'u');
    }

    static parseDate(key: any, value: any): Date {
        if (DateUtils.isIsoDateString(value)) {
            const dateWithoutTimezone = value.split('+')[0];
            return new Date(dateWithoutTimezone);
        }
        return value;
    }

    static isIsoDateString(value: any): boolean {
        return value && typeof value === 'string' && ISODateFormat.test(value);
    }

    static isNowBetween(from?: Date, until?: Date): boolean {
        if (!from)
        {
            return true;
        }

        const now = new Date();

        if (!until)
        {
            return (now > from);
        }

        return (now > from && now < until);
    }

}

export default DateUtils;
